import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Table,
} from "reactstrap";
import classnames from "classnames";
import AttendanceReportSearchForm from "../Attendance/Report/Search/Components/SearchForm";
import AttendanceSummarySearchResult from "../Attendance/Report/SearchResult";
import {
  ATTENDANCE_SUMMARY_ALL_USERS,
  GET_ALL_HOLYDAYS_BY_YEAR,
} from "@/GraphQL/Queries";
import { useQuery } from "@apollo/client";
import { isEmptyObject } from "@/utils/utilities";
import { dateTime } from "@/utils/helpers";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import {
  calculateTotalLeaveDaysPerType,
  flattenPendingLeaveArray,
} from "@/utils/pendingLeave";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DownloadAttendanceReport from "./DownloadAttendanceReport";
import { MdOutlineDownloading } from "react-icons/md";
const UserReport = () => {
  const [activeTab, setActiveTab] = useState("1");
  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [results, setResults] = useState({});
  const [searchData, setSearchData] = useState({});
  const [currentTime, setCurrentTime] = useState(new Date());

  const isEmptyResults = isEmptyObject(results);
  const isEmptySearchData = isEmptyObject(searchData);

  const { loading, error, data } = useQuery(ATTENDANCE_SUMMARY_ALL_USERS);
  console.log("🚀 ~ UserReport ~ data:", data);

  const allUserAttendance = data?.ATTENDANCE_SUMMARY_ALL_USERS?.summaries ?? [];

  // test
  const [filterYear, setFilterYear] = useState(
    Number(moment(new Date()).format("YYYY"))
  );
  const getAllHolydaysByYear = useQuery(GET_ALL_HOLYDAYS_BY_YEAR, {
    skip: !filterYear,
    variables: {
      year: filterYear,
    },
  });
  const holidayss = getAllHolydaysByYear?.data?.getAllHolydaysByYear;
  const userData = data?.attendaceSummaryAllUsers?.summaries?.map((user) => {
    const pendingLeaveSummaryArray = calculateTotalLeaveDaysPerType(
      user?.totalPendingLeaveDays || [],
      holidayss
    );
    const totalLeaveDays = pendingLeaveSummaryArray?.reduce((total, item) => {
      Object.entries(item).forEach(([key, value]) => {
        if (key !== "id") {
          total += value;
        }
      });
      return total;
    }, 0);

    return {
      name: user?.user?.name,
      email: user?.user?.email,
      totalWorkingDays: user?.totalWorkingDays,
      totalAttendance: user?.totalAttendance,
      totalLeave: user?.totalLeave,
      totalLateLogin: user?.totalLateLogin,
      totalPendingLeaveDays: totalLeaveDays,
      totalAuthorizedLeave: user?.totalAuthorizedLeave,
    };
  });
  console.log("🚀 ~ UserReport ~ userData:", userData);

  const handleDownloadExcel = (data) => {
    if (!data || data.length === 0) return;

    // Transform the user data to a flat structure
    const worksheetData = data.map((user, index) => ({
      "#": index + 1,
      Name: user.name,
      Email: user.email,
      "Total Working Days": user.totalWorkingDays,
      "Present Days": user.totalAttendance,
      "Absent Days": Math.max(
        0,
        Math.floor(
          Number(user?.totalWorkingDays ?? 0) -
            Number(user?.totalAttendance ?? 0)
        )
      ),
      // "Absent Days": user.totalWorkingDays - user.totalAttendance,
      "Late Logins": `${user.totalLateLogin} ${
        user.totalAuthorizedLeave
          ? `(Authorized: ${user.totalAuthorizedLeave})`
          : ""
      }`,
      // "Late Logins": user.totalLateLogin,
      "Pending Leaves": user.totalPendingLeaveDays,
      "Total Leave": user.totalLeave,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "User Report");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `User_Report_${moment().format("YYYY-MM-DD")}.xlsx`);
  };

  const onClear = () => {
    setSearchData({});
    setResults({});
  };

  return (
    <>
      <Col md={12}>
        <Card>
          <CardBody>
            <h4>User Report</h4>
            <Nav tabs className="justify-content-center">
              <NavItem>
                <NavLink
                  style={{
                    color: activeTab === "1" ? "#495057" : "#495057",
                  }}
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => toggleTab("1")}
                >
                  All User Report
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{
                    color: activeTab === "2" ? "#495057" : "#495057",
                  }}
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => toggleTab("2")}
                >
                  Attendance Report
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab} className="pt-3">
              {/* Tab 1: All User Attendance */}
              <TabPane tabId="1">
                <h4 className="text-center">All Users Attendance Summary</h4>{" "}
                {/* <Button
                  color="primary"
                  onClick={() => handleDownloadExcel(userData)}
                >
                  Download Excel
                </Button> */}
                <Button onClick={() => handleDownloadExcel(userData)}>
                  Summary <MdOutlineDownloading />
                </Button>
                {loading ? (
                  <SubmitLoading color="black" />
                ) : error ? (
                  <p className="text-danger">Error: {error.message}</p>
                ) : (
                  <div>
                    <Col md={6}>
                      <div className="text-success">
                        {data?.attendaceSummaryAllUsers?.message}
                      </div>
                    </Col>
                    <Table responsive striped bordered hover>
                      <thead className="thead-dark">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Total Working Days</th>
                          <th>Present Days</th>
                          <th>Absent Days</th>
                          <th>Late Logins</th>
                          <th>Pending Leaves</th>
                          <th>Total Leave</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map((user, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.totalWorkingDays}</td>
                            <td>{user.totalAttendance}</td>
                            <td>
                              {Math.max(
                                0,
                                Math.floor(
                                  Number(user?.totalWorkingDays ?? 0) -
                                    Number(user?.totalAttendance ?? 0)
                                )
                              )}
                            </td>
                            <td>
                              {`${user.totalLateLogin} ${
                                user.totalAuthorizedLeave
                                  ? `(Authorized: ${user.totalAuthorizedLeave})`
                                  : ""
                              }`}
                            </td>
                            {/* <td>
                        
                              {user.totalWorkingDays - user.totalAttendance}
                            </td> */}
                            <td>{user.totalPendingLeaveDays}</td>
                            <td>{user.totalLeave}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </TabPane>

              {/* Tab 2: Attendance Report */}
              <TabPane tabId="2">
                <h4 className="text-center">Attendance Report</h4>
                <Row>
                  <Col md={6} className="mx-auto">
                    <AttendanceReportSearchForm
                      setResults={setResults}
                      setSearchData={setSearchData}
                    />
                  </Col>
                </Row>

                {!isEmptyResults && !isEmptySearchData && (
                  <Col md={12}>
                    <Card>
                      <CardBody>
                        <Row className="align-items-center">
                          <Col md={6}>
                            <div className="text-success">
                              Search for{" "}
                              {dateTime(searchData?.start_date, "D MMM YYYY")}{" "}
                              to {dateTime(searchData?.end_date, "D MMM YYYY")}
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="text-right">
                              <Button onClick={onClear} className="btn-sm mb-0">
                                Clear
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                )}

                {!isEmptyResults && (
                  <Col md={12}>
                    {results?.status_code === 200 && (
                      <AttendanceSummarySearchResult data={results} />
                    )}
                    {results?.status_code === 404 && (
                      <div>{results?.message}</div>
                    )}
                  </Col>
                )}
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default UserReport;
